<!-- ── Loader inicial ───────────────────────────────────────────── -->
<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{ 'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">

  <div class="grid align-items-center mb-3">
    <div class="col-1" *ngIf="!detalle">
      <button pButton type="button"
              class="btn-primary-full w-full"
              label="{{ 'BTN_AGREGAR' | translate }}"
              icon="fa fa-plus"
              [disabled]="mostrarFormulario"
              [ngClass]="{'p-button-secondary': mostrarFormulario}"
              (click)="agregar()"></button>
    </div>
    <div class="col-5" [ngClass]="detalle ? 'col-offset-7' : 'col-offset-6'" *ngIf="!mostrarFormulario">
      <input type="text" pInputText
             placeholder="{{ 'LBL_BUSCAR' | translate }}"
             class="w-full input-search-premium"
             [(ngModel)]="search"
             (input)="dt.filter($any($event.target).value, 'nombreCategoriasMetasAhorro', 'contains')">
    </div>
  </div>

  <div class="form-transition-container" [class.visible]="mostrarFormulario && !detalle">
    <div class="p-4 mb-4" [ngClass]="editando ? 'contenedor-form-editar' : 'contenedor-form-categorias'">

      <h6 class="titulo-form-categoria mb-3">
        {{ (editando ? 'PRODUCTOCATEGORIAS.LBL_EDITARCATEGORIA' : 'PRODUCTOCATEGORIAS.LBL_AGREGARCATEGORIA') | translate }}
      </h6>

      <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate>

        <div class="grid form-group align-items-end">

          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label class="label-form">* {{ 'PRODUCTOCATEGORIAS.LBL_CATEGORIA' | translate }}</label>

              <ng-container *ngIf="!editando">
                <p-dropdown id="idCategoriaMetaAhorro"
                            [options]="lisCategoriasMetasAhorro"
                            formControlName="idCategoriaMetaAhorro"
                            placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                            optionValue="value"
                            optionLabel="label"
                            [filter]="true"
                            appendTo="body"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                            styleClass="w-full">
                </p-dropdown>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submitted && f.idCategoriaMetaAhorro.errors?.required">
                  {{ 'PRODUCTOCATEGORIAS.LBL_CATEGORIA' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                </div>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submitted && f.idCategoriaMetaAhorro.errors?.categoriaExistente">
                  {{ 'PRODUCTOCATEGORIAS.MSG_CATEGORIA_EXISTENTE' | translate }}
                </div>
              </ng-container>

              <ng-container *ngIf="editando">
                <input type="text" pInputText
                       class="w-full"
                       [value]="registroEditando?.nombreCategoriasMetasAhorro"
                       [disabled]="true"
                       readonly>
              </ng-container>
            </div>
          </div>

          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form flex align-items-center gap-2 indicador-check">
              <p-checkbox formControlName="plazoObligatorio"
                          binary="true"
                          inputId="chkPlazoObl">
              </p-checkbox>
              <label for="chkPlazoObl" class="label-form mb-0 cursor-pointer">
                {{ 'PRODUCTOCATEGORIAS.LBL_PLAZOOBLIGATORIO' | translate }}
              </label>
            </div>
          </div>

          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form flex align-items-center gap-2 indicador-check">
              <p-checkbox formControlName="montoObligatorio"
                          binary="true"
                          inputId="chkMontoObl">
              </p-checkbox>
              <label for="chkMontoObl" class="label-form mb-0 cursor-pointer">
                {{ 'PRODUCTOCATEGORIAS.LBL_MONTOOBLIGATORIO' | translate }}
              </label>
            </div>
          </div>

          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form flex align-items-center gap-2 indicador-check">
              <p-inputSwitch formControlName="indicadorHabilitado"
                             inputId="swHabilitado">
              </p-inputSwitch>
              <label for="swHabilitado" class="label-form mb-0 cursor-pointer">
                {{ 'PRODUCTOCATEGORIAS.LBL_HABILITADO' | translate }}
              </label>
            </div>
          </div>
        </div>

        <div class="grid form-group align-items-end">

          <!-- Monto mínimo -->
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label class="label-form">* {{ 'PRODUCTOCATEGORIAS.LBL_MONTOMINIMO' | translate }}</label>
              <input type="text" pInputText
                     id="idMontoMinimo"
                     formControlName="montoMinimo"
                     placeholder="$0"
                     class="w-full"
                     (keypress)="soloNumericosConDecimal($event)"
                     (blur)="formatearCampoMoneda('montoMinimo')">
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && f.montoMinimo.errors?.required">
                {{ 'PRODUCTOCATEGORIAS.LBL_MONTOMINIMO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
              </div>
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && f.montoMinimo.errors?.montoMaxEnteros ||  f.montoMinimo.errors?.montoMaxDecimales">
                {{ 'PRODUCTOCATEGORIAS.MSG_MONTO_MAX_ENTEROS' | translate }}
              </div>
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && formulario.hasError('montoMinMayorMax')">
                {{ 'PRODUCTOCATEGORIAS.MSG_MONTO_MIN_MAYOR_MAX' | translate }}
              </div>
            </div>
          </div>

          <!-- Monto máximo -->
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label class="label-form">* {{ 'PRODUCTOCATEGORIAS.LBL_MONTOMAXIMO' | translate }}</label>
              <input type="text" pInputText
                     id="idMontoMaximo"
                     formControlName="montoMaximo"
                     placeholder="$0"
                     class="w-full"
                     (keypress)="soloNumericosConDecimal($event)"
                     (blur)="formatearCampoMoneda('montoMaximo')">
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && f.montoMaximo.errors?.required">
                {{ 'PRODUCTOCATEGORIAS.LBL_MONTOMAXIMO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
              </div>
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && f.montoMaximo.errors?.montoMaxEnteros || f.montoMaximo.errors?.montoMaxDecimales">
                {{ 'PRODUCTOCATEGORIAS.MSG_MONTO_MAX_ENTEROS' | translate }}
              </div>
            </div>
          </div>

          <!-- Plazo mínimo -->
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label class="label-form">* {{ 'PRODUCTOCATEGORIAS.LBL_PLAZOMINIMO' | translate }}</label>
              <input type="number" pInputText
                     id="idPlazoMinimo"
                     formControlName="plazoMinimo"
                     placeholder="0"
                     min="1"
                     class="w-full"
                     (keypress)="soloNumericos($event)">
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && f.plazoMinimo.errors?.required">
                {{ 'PRODUCTOCATEGORIAS.LBL_PLAZOMINIMO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
              </div>
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && f.plazoMinimo.errors?.min">
                {{ 'PRODUCTOCATEGORIAS.MSG_PLAZO_MIN_CERO' | translate }}
              </div>
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && formulario.hasError('plazoMinMayorMax')">
                {{ 'PRODUCTOCATEGORIAS.MSG_PLAZO_MIN_MAYOR_MAX' | translate }}
              </div>
            </div>
          </div>

          <!-- Plazo máximo -->
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label class="label-form">* {{ 'PRODUCTOCATEGORIAS.LBL_PLAZOMAXIMO' | translate }}</label>
              <input type="number" pInputText
                     id="idPlazoMaximo"
                     formControlName="plazoMaximo"
                     placeholder="0"
                     max="360"
                     class="w-full"
                     (keypress)="soloNumericos($event)">
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && f.plazoMaximo.errors?.required">
                {{ 'PRODUCTOCATEGORIAS.LBL_PLAZOMAXIMO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
              </div>
              <div class="p-message p-messages-error p-corner-all"
                   *ngIf="submitted && f.plazoMaximo.errors?.max">
                {{ 'PRODUCTOCATEGORIAS.MSG_PLAZO_MAX_360' | translate }}
              </div>
            </div>
          </div>
        </div>

        <div class="grid">
          <div class="col-12 text-center py-3">
            <div *ngIf="!guardando" class="flex justify-content-center gap-3">
              <button type="button"
                      class="btn-cancelar-categoria"
                      pButton
                      label="{{ 'BTN_CANCELAR' | translate }}"
                      (click)="cancelarEdit()">
              </button>
              <button type="submit"
                      class="btn-guardar-categoria"
                      pButton
                      icon="fa fa-check-circle"
                      label="{{ 'BTN_GUARDAR' | translate }}">
              </button>
            </div>
            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{ 'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>

      </form>
    </div>
  </div>

  <div class="grid">
    <div class="col-5 col-offset-7" *ngIf="mostrarFormulario && !detalle">
      <input type="text" pInputText
             placeholder="{{ 'LBL_BUSCAR' | translate }}"
             class="w-full input-search-premium"
             [(ngModel)]="search"
             (input)="dt.filter($any($event.target).value, 'nombreCategoriasMetasAhorro', 'contains')">
    </div>
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" #dt
               [value]="lisProductosCategorias"
               [paginator]="true" [rows]="10" paginatorPosition="bottom"
               styleClass="table-premium tabla-categorias">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns"
                [pSortableColumn]="col.field"
                [pSortableColumnDisabled]="!col.sort"
                class="text-center">
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{ row.nombreCategoriasMetasAhorro }}</td>
            <td>{{ formatearMoneda(row.montoMinimo) }}</td>
            <td>{{ formatearMoneda(row.montoMaximo) }}</td>
            <td>{{ row.plazoMinimo }}</td>
            <td>{{ row.plazoMaximo }}</td>
            <td>
              <div class="indicador-wrapper">
                <p-checkbox [(ngModel)]="row.plazoObligatorio" binary="true" disabled="true"></p-checkbox>
              </div>
            </td>
            <td>
              <div class="indicador-wrapper">
                <p-checkbox [(ngModel)]="row.montoObligatorio" binary="true" disabled="true"></p-checkbox>
              </div>
            </td>
            <td>
              <span [ngClass]="row.indicadorHabilitado ? 'estado-habilitado' : 'estado-inhabilitado'">
                {{ obtenerEstado(row.indicadorHabilitado) }}
              </span>
            </td>
            <td class="td-acciones">
              <div class="acciones-cell">
                <button *ngIf="!detalle"
                        type="button"
                        class="btn-editar-categoria"
                        icon="fa fa-pencil"
                        pButton
                        data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}"
                        (click)="editar(row)">
                </button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
